import { render, staticRenderFns } from "./LosedFeatureBlock.vue?vue&type=template&id=8c4de1c8&scoped=true&"
import script from "./LosedFeatureBlock.vue?vue&type=script&lang=js&"
export * from "./LosedFeatureBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4de1c8",
  null
  
)

export default component.exports